// src/environments/environment.staging.ts
import { env } from './.env';
export const environment = {
  ...env,
  production: true,
  debug: false,
  version: env['npm_package_version'],

  // Dummy/test membership payment (no real gateway). Dev + staging only.
  paymentTestMode: true,

  // Backend staging strips the "stagesogha3phiiron1aeq." prefix, then matches domain_config (key 5).
  serverUrl: 'https://stagesogha3phiiron1aeq.wolfpackglobalhealth.com/api',
  apiUrl: 'https://stagesogha3phiiron1aeq.wolfpackglobalhealth.com/api',
  chatUrl: 'https://s.chat.wolfpackglobalhealth.com',
  conferenceDomain: 's.meet.wolfpackglobalhealth.com',

  // Which acquisition funnel /r serves. Must match the backend's
  // GLOBALHEALTH_FUNNEL_MODE (it decides where the magic-link mail points):
  //   'membership' — the single WolfPack membership funnel (five screens)
  //   'quiz'       — the retired "Health Finder" quiz, kept for reactivation
  globalHealthFunnelMode: 'membership' as 'membership' | 'quiz',

  allowBalanceEdit: true,

  // Matomo Analytics Configuration
  matomo: {
    enabled: false, // Matomo switched off everywhere on 2026-10-10 (customer decision): replaced by the WolfPack Tracking Engine
    siteId: 4, // Global Health staging site ID
    trackerUrl: 'https://a.fac3less.app/matomo.php',
    scriptUrl: 'https://a.fac3less.app/matomo.js',
    requireConsent: false,
    enableHeartBeatTimer: true,
    heartBeatTimerInterval: 15,
    enableLinkTracking: true,
    trackAppInitialLoad: true
  }
};